<script>import { setContext } from 'svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
import { twMerge } from 'tailwind-merge';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let type = 'ghost';
const defaultClass = 'flex items-center space-x-4 stwui-breadcrumbs';
const solidClass = 'border border-border bg-surface rounded-md px-6';
$: finalClass = twMerge(defaultClass, type === 'solid' ? solidClass : false, $$props.class);
setContext('breadcrumbs-type', type);
</script>

<nav class="flex">
	<ol
		class={finalClass}
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class'])}
	>
		<slot />
	</ol>
</nav>

<style global>
	:global(.stwui-breadcrumbs :global(.stwui-breadcrumbs-crumb:first-of-type) :global(.divider)) {
		display: none;
	}
</style>
